var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconsFilledExchangeAlt24Px(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "2EB5CE6C-3636-4B06-B0EA-167DF97C4B54") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/Filled/exchange-alt_24px"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fillRule: "nonzero",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-1)",
    id: "\\uD83C\\uDF08-Icon-Color"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "exchange-alt",
    transform: "translate(0.000000, 0.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0,3.53125 L0,3.03125 C0,2.61703125 0.33578125,2.28125 0.75,2.28125 L12,2.28125 L12,0.78125 C12,0.11353125 12.8093438,-0.2200625 13.2803438,0.25090625 L15.7803438,2.75090625 C16.0732187,3.0438125 16.0732187,3.5186875 15.7803438,3.8115625 L13.2803438,6.3115625 C12.811125,6.7806875 12,6.45175 12,5.78125 L12,4.28125 L0.75,4.28125 C0.33578125,4.28125 0,3.94546875 0,3.53125 Z M15.25,8.28125 L4,8.28125 L4,6.78125 C4,6.1151875 3.1918125,5.77875 2.71965625,6.25090625 L0.21965625,8.75090625 C-0.07321875,9.0438125 -0.07321875,9.5186875 0.21965625,9.8115625 L2.71965625,12.3115625 C3.18928125,12.7811562 4,12.4511563 4,11.78125 L4,10.28125 L15.25,10.28125 C15.6642187,10.28125 16,9.94546875 16,9.53125 L16,9.03125 C16,8.61703125 15.6642187,8.28125 15.25,8.28125 Z"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsFilledExchangeAlt24Px);
export default __webpack_public_path__ + "static/media/Icons_Filled_exchange-alt_24px.7b163ccb.svg";
export { ForwardRef as ReactComponent };